import { render, staticRenderFns } from "./RasterItem.vue?vue&type=template&id=2b8b3022&scoped=true"
import script from "./RasterItem.vue?vue&type=script&lang=js"
export * from "./RasterItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8b3022",
  null
  
)

export default component.exports